import React from "react";
import { useParams, Link } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Container,
  Paper,
  Divider,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useGetNewsletterByIdQuery } from "./api/newsletterApi";

const NewsletterDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data:response, isLoading, error } = useGetNewsletterByIdQuery(id!);
 const data=response?.data;
  if (isLoading) {
    return (
      <Box mt={5} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Box mt={5} display="flex" justifyContent="center">
        <Alert severity="error">Failed to load newsletter. Please try again later.</Alert>
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Button component={Link} to="/newsletters" startIcon={<ArrowBackIcon />} sx={{ mb: 2 }}>
        Back to Newsletters
      </Button>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" gutterBottom>
          {data.subject}
        </Typography>

       <Typography variant="subtitle2" color="text.secondary">
  Created at:{" "}
  {new Date(data.created_at).toLocaleString("en-US", {
    year: "numeric",
    month: "long",  
    day: "numeric",
  })}
</Typography>


        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            '& img': { maxWidth: '100%' },
            '& p': { mt: 2 },
            '& h1,h2,h3': { mt: 3 },
          }}
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
      </Paper>
    </Container>
  );
};

export default NewsletterDetailPage;
